<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}">
        <v-form v-if='edited_comment_id' @submit.prevent="delete_idea_comment({comment_id: edited_comment_id, reason: textArea})">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('delete_comment_modal')">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Удалить комментарий")}}</v-card-title>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Введите причину")}}</div>
                    <textareaBase v-model='textArea' :placeholder="$t('Введите текст')" rows="4" />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Удалить")}}</buttonRed>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    textareaBase,
    inputBase,
  },
  data() {
    return {
      text: '',
    };
  },
  computed: {
    ...mapGetters('ideas_bank', [
      'themes',
      'ideas_bank_modal',
      'edit_comment_modal',

    ]),
    ...mapGetters('ideas_bank/comments', [
      'edited_comment_id',
      'current_edited_comment',
    ]),
    textArea: {
      get() {
        return this.text;
      },
      set($event) {
        // return this.DELETE_COMMENT_ADMIN({id: this.edited_comment_id, value: $event.target.value});
      },
    },
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapMutations('ideas_bank/comments', [
      'EDIT_COMMENT_TEXT',
    ]),
    ...mapActions('ideas_bank/comments', [
      'edit_comment',
      'delete_idea_comment',
    ]),
    comment_text(ev) {
      this.text = ev;
    },
  },


};
</script>
